import { useState } from "react"
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material"
import DetallesContrato from "../../components/DetallesContrato/DetallesContrato"
import DetallesRGPD from "../../components/DetallesRGPD/DetallesRGPD"
import Firmas from "../../components/Firmas/Firmas"
import { useAlumno } from "../../utils/useAlumno"
import logo from '../../assets/logo.png'
import AceptacionCondiciones from "../../components/AceptacionCondiciones/AceptacionCondiciones"
import { getDatosCentro, requiresAdditionalSignature } from "../../utils/helpers"
import * as condiciones from "../../utils/pdf/condiciones"
import * as rgpd from "../../utils/pdf/rgpd"
import { uploadCondiciones, uploadRGPD } from "../../utils/api"
import AceptaChip from "../../components/AceptaChip/AceptaChip"
import DescargarDocumentos from "../../components/DescargarDocumentos/DescargarDocumentos"
import ConfirmButton from "../../components/ConfirmButton/ConfirmButton"
import css from './Condiciones.module.css'

const Condiciones = () => {
  
  const { token, alumno, isReady } = useAlumno()

  const nombre = alumno?.nombre.trim() + ' ' + alumno?.apellidos.trim()
  const centro = getDatosCentro(alumno?.centro)

  const [aceptaCondiciones, setAceptaCondiciones] = useState(false)
  const [aceptaProteccionDatos, setAceptaProteccionDatos] = useState(false)

  const [firmaAlumno, setFirmaAlumno] = useState(null)
  const [firmaTutor, setFirmaTutor] = useState(null)

  const [guardadoCondiciones, setGuardadoCondiciones] = useState(false)
  const [guardadoRGPD, setGuardadoRGPD] = useState(false)
  const [isGuardandoCondiciones, setIsGuardandoCondiciones] = useState(false)
  const [isGuardandoRGPD, setIsGuardandoRGPD] = useState(false)
  const [errorGuardado, setErrorGuardado] = useState(false)

  const necesitaFirma = requiresAdditionalSignature(alumno?.fechaNacimiento)
  const hasFirmaAlumno = !!firmaAlumno
  const hasFirmaTutor = !!firmaTutor
  const hasRequiredSignatures = necesitaFirma ? hasFirmaAlumno && hasFirmaTutor : hasFirmaAlumno
  const hasAgreed = aceptaCondiciones && aceptaProteccionDatos
  const isDocumentReady = hasRequiredSignatures && hasAgreed
  const isUploading = isGuardandoCondiciones || isGuardandoRGPD
  const isComplete = isReady && guardadoCondiciones && guardadoRGPD

  const handleDownloadCondiciones = ()=> {
    condiciones.getPDF({ nombre, centro, firmaAlumno, firmaTutor }).then(condiciones.downloadBlob)
  }

  const handleDownloadRGPD = ()=> {
    rgpd.getPDF({ nombre, centro, firmaAlumno, firmaTutor }).then(rgpd.downloadBlob)
  }

  const handleUploadDocuments = ()=> {
    setErrorGuardado(false)
    if (!guardadoCondiciones) {
      setIsGuardandoCondiciones(true)
      condiciones.getPDF({ nombre, centro, firmaAlumno, firmaTutor })
        .then(blob=> uploadCondiciones({ token, alumnoId: alumno.id, blob }))
        .then(({ success })=> {
          if (!success) setErrorGuardado(true)
          else setGuardadoCondiciones(true)
        })
        .finally(()=> setIsGuardandoCondiciones(false))
    }
    if (!guardadoRGPD) {
      setIsGuardandoRGPD(true)
      rgpd.getPDF({ nombre, centro, firmaAlumno, firmaTutor })
        .then(blob=> uploadRGPD({ token, alumnoId: alumno.id, blob }))
        .then(({ success })=> {
          if (!success) setErrorGuardado(true)
          else setGuardadoRGPD(true)
        })
        .finally(()=> setIsGuardandoRGPD(false))
    }
  }

  if (!isReady) return null

  return (
    <div className={css.main}>
      <img className={css.imagen} src={logo} alt="logo" />
      <p className={css.title}>
        👋 Hola, <strong>{nombre}</strong>, a continuación podrás ver nuestra política de contratación y protección de datos.
        Si tienes cualquier duda, no dudes en consultarnos.
      </p>
      <Accordion className={css.accordion}>
        <AccordionSummary expandIcon={<i className='material-icons'>expand_more</i>}>
          Condiciones de contratacion
          {aceptaCondiciones && <AceptaChip />}
        </AccordionSummary>
        <AccordionDetails>
          <DetallesContrato />
        </AccordionDetails>
      </Accordion>
      <Accordion className={css.accordion}>
        <AccordionSummary expandIcon={<i className='material-icons'>expand_more</i>}>
          Protección de datos (RGPD)
          {aceptaProteccionDatos && <AceptaChip />}
        </AccordionSummary>
        <AccordionDetails>
          <DetallesRGPD centro={centro} />
        </AccordionDetails>
      </Accordion>
      <AceptacionCondiciones
        aceptaCondiciones={aceptaCondiciones}
        aceptaProteccionDatos={aceptaProteccionDatos}
        setAceptaCondiciones={setAceptaCondiciones}
        setAceptaProteccionDatos={setAceptaProteccionDatos}
      />
      {aceptaCondiciones && aceptaProteccionDatos && (
        <Firmas 
          firmaAlumno={firmaAlumno}
          firmaTutor={firmaTutor}
          necesitaFirmaTutor={necesitaFirma}
          setFirmaAlumno={setFirmaAlumno}
          setFirmaTutor={setFirmaTutor}
        />
      )}
      {isDocumentReady && (
        <ConfirmButton
          isError={errorGuardado}
          isUploading={isUploading}
          isComplete={isComplete}
          onClick={handleUploadDocuments}
        />
      )}
      {isComplete && (
        <DescargarDocumentos 
          onDownloadCondiciones={handleDownloadCondiciones} 
          onDownloadRGPD={handleDownloadRGPD} 
        />
      )}
    </div>
  )
}

export default Condiciones